import { IoGitNetworkOutline } from "react-icons/io5";
import RegionListPage from "./RegionListPage";
import SubDivisionCreateModal from "./SubDivisionCreateModal";

const columns = [
  { header: "Sub-Division List", key: "subDivision" },
  { header: "Sub-Division Id", key: "subDivisionId" },
  { header: "State", key: "state" },
  { header: "Area", viewKey: "areaList", viewTitle: "Area List" },
  { header: "Created By", key: "createdBy" },
  { header: "Location Description", key: "locationDescription" },
];

const SubDivisionList = () => (
  <RegionListPage
    field="subDivision"
    label="Sub-Division"
    viewTab="Sub-Division"
    CreateIcon={IoGitNetworkOutline}
    createLabel="Create New Sub-Division"
    columns={columns}
    renderCreate={(p) => <SubDivisionCreateModal {...p} />}
  />
);

export default SubDivisionList;